"use client"

import { useEffect } from "react"
import { Crisp } from "crisp-sdk-web"
import config from "@/config"

const CrispChat = () => {
  useEffect(() => {
    Crisp.configure(config.crisp?.id)
    Crisp.chat.hide() // Hide the chat widget by default
  }, [])
  
  return null
}

const handleSupportClick = (e: React.MouseEvent) => {
  e.preventDefault()
  if (config.crisp?.id) {
    Crisp.chat.show()
    Crisp.chat.open()
  }
}

export { CrispChat, handleSupportClick }